import {ActionList} from '@primer/react'
import {AssigneeVisual} from './AssigneeVisual'
import {isCopilot} from './copilot-user'
import {hovercardAttributesForActor} from '@github-ui/hovercards'
import {VALUES} from './constants/values'
import {ProfileReference} from '@github-ui/profile-reference'
import {isFeatureEnabled} from '@github-ui/feature-flags'

import styles from './Assignees.module.css'

export type Assignee = {
  login: string
  name?: string | null
  avatarUrl: string
  profileResourcePath?: string | null | undefined
  id: string
}
export type AssigneesProps = {
  assignees: Assignee[]
  testId?: string
}

export function Assignees({assignees, testId}: AssigneesProps) {
  return (
    <ActionList variant={'full'} className={styles.assigneesList}>
      {[...assignees].sort(sortByLogin).map(({login, name, avatarUrl, profileResourcePath, id}) => {
        const displayName = isCopilot(login) ? VALUES.copilot.displayName : login
        return (
          <ActionList.LinkItem
            key={id}
            href={profileResourcePath ?? undefined}
            target="_blank"
            {...hovercardAttributesForActor(login, {isCopilot: isCopilot(login)})}
          >
            <ActionList.LeadingVisual>
              <AssigneeVisual login={login} id={id} avatarUrl={avatarUrl} />
            </ActionList.LeadingVisual>
            <div data-testid={testId} className={styles.assigneeNameLabel}>
              {isFeatureEnabled('render_user_display_name') ? (
                <ProfileReference login={displayName} profileName={name} />
              ) : (
                displayName
              )}
            </div>
          </ActionList.LinkItem>
        )
      })}
    </ActionList>
  )
}

function sortByLogin(a: Pick<Assignee, 'login'>, b: Pick<Assignee, 'login'>) {
  return a.login === b.login ? 0 : a.login > b.login ? 1 : -1
}

try{ Assignees.displayName ||= 'Assignees' } catch {}